export default __webpack_public_path__ + "static/media/DaviMarcos_05.e7e59e8a.jpg";